<template>
  <div>
    <slot v-bind="{label, fieldLabel, fieldHint, errors, isDanger, isSuccess, id, name, enabled, fieldValue, doValidate, triggerChangeAndValidate}">
      <form-label v-if="label" :text="fieldLabel" :hint="fieldHint" :for="id"></form-label>
      <div class="uk-form-controls">
        <slot name="input" v-bind="{isDanger, isSuccess, id, name, enabled, setValue, doValidate, triggerChangeAndValidate}"></slot>
      </div>
      <form-error v-for="(error, index) in errors" :key="index" :error="error"></form-error>
    </slot>
  </div>
</template>

<script>
  import FormField from "rubinred/forms/js/mixins/FormField";

  export default {
    mixins: [FormField],
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/forms/assets/js/components/CustomField.vue